import { redirect } from 'next/navigation';
import { getBaseUrl } from './getBaseUrl';
import { fetchRootTenantConfig } from './fetchRootTenantConfig';
import { isRootTenant } from './resolveTenantId';


export const fetchData = async (id: string | undefined) => {
  if (!id)
    return redirect('https://wenkoo.com.cn')
  try {
    // 根域名机构 (C) 走 functionConfig 接口, 其余机构走 tenant/queryUsableById
    if (isRootTenant(id)) {
      const rootData = await fetchRootTenantConfig(id);
      if (rootData) return rootData;
      return redirect('https://wenkoo.com.cn')
    }

    const baseUrl = await getBaseUrl(id);
    const response = await fetch(`${baseUrl}/tenant/queryUsableById?id=${id}`);
    const res = await response.json();
    if (res.code === 0 && res.data) {
      const data = res.data;
      return data;
    }

    redirect('https://wenkoo.com.cn')
  } catch {
    redirect('https://wenkoo.com.cn')
  }
}

export const fetchAgentViewList = async (id: string) => {
  const baseUrl = await getBaseUrl(id);
  const response = await fetch(`${baseUrl}/agentDemoType/getDemoList?tenantId=${id}`, {
    method: 'POST',
  });
  const res = await response.json();
  console.log(res);
  if (res.code === 0) {
    return res.data;
  }

  return null
}
